import { render, staticRenderFns } from "./middle-warehouse.vue?vue&type=template&id=319232cc&scoped=true&"
import script from "./middle-warehouse.vue?vue&type=script&lang=ts&"
export * from "./middle-warehouse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319232cc",
  null
  
)

export default component.exports